<template>
  <section
    :class="!getSingleProduct.productName ? 'min-h-screen' : ''"
    class="mt-14 bg-subtleGray"
  >
    <div class="bg-gray-800 px-3 md:px-6 2xl:px-0">
      <div v-if="getSingleProduct.productName" class="w-full max-w-1xl mx-auto">
        <div class="py-3 md:py-6 md:px-1 2xl:px-0 w-full max-w-1xl mx-auto">
          <header
            class="
              pt-3
              flex flex-col
              md:flex-row
              items-start
              space-y-3
              md:space-y-0
              justify-between
            "
          >
            <div>
              <h1 class="font-bold text-lg md:text-3xl text-white">
                {{ getSingleProduct.productName }}
              </h1>

              <h3 class="mt-2 text-xs md:text-sm text-gray-200">
                By
                <router-link
                  :to="`/user/${getSingleProduct.user.userName}`"
                  class="hover:underline"
                  >{{ getSingleProduct.user.userName }}</router-link
                >
                in
                <router-link
                  class="hover:underline"
                  :to="`/${getSingleProduct.category
                    .toLowerCase()
                    .split(' ')
                    .join('-')}/pg-1`"
                  >{{ getSingleProduct.category }}
                </router-link>
              </h3>
            </div>

            <div
              class="pt-2 flex flex-col items-center justify-center space-x-2"
            >
              <div class="flex items-center justify-center">
                <router-link
                  to="/all-items"
                  class="
                    font-semibold
                    text-xs text-gray-300
                    flex
                    items-center
                    justify-center
                    space-x-1
                  "
                >
                  <svg
                    class="w-4 h-4 mb-1 text-brandPurple"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z"
                    />
                  </svg>
                  <span class="whitespace-nowrap">All items</span>
                </router-link>

                <svg
                  class="text-brandPurple w-4 h-4"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M9 5l7 7-7 7"
                  />
                </svg>

                <router-link
                  :to="`/${getSingleProduct.category
                    .toLowerCase()
                    .split(' ')
                    .join('-')}/pg-1`"
                  class="font-semibold text-xs text-gray-300"
                >
                  {{ getSingleProduct.category }}
                </router-link>
                <svg
                  class="text-brandPurple w-4 h-4"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M9 5l7 7-7 7"
                  />
                </svg>

                <router-link
                  :to="`/${getSingleProduct.category
                    .toLowerCase()
                    .split(' ')
                    .join('-')}/${getSingleProduct.subCategory
                    .toLowerCase()
                    .split(' ')
                    .join('-')}/pg-1`"
                  class="font-semibold text-xs text-gray-300"
                >
                  {{ getSingleProduct.subCategory }}
                </router-link>
              </div>
            </div>
          </header>
        </div>

        <!-- content -->
        <div
          :class="getSingleProduct && !getSingleProduct.peaks ? '-mb-16' : ''"
          class="
            mt-2
            pb-5
            md:-mt-2
            flex
            items-start
            flex-col
            md:flex-row
            justify-between
            bg-dark2Overlay
            rounded-md
            space-y-10
            md:space-y-0 md:space-x-12
          "
        >
          <!-- product and desc -->
          <div class="w-full flex flex-col items-start justify-start">
            <!-- video or Audio -->
            <!-- video -->
            <div
              v-if="
                !getSingleProduct.peaks &&
                getSingleProduct.category.toLowerCase() !== 'photo'
              "
              class="w-full"
            >
              <div
                @mouseenter="showPlay = true"
                @mouseleave="showPlay = false"
                class="image-container rounded-md overflow-hidden"
              >
                <div class="absolute inset-0 rounded-md overflow-hidden">
                  <div
                    class="
                      relative
                      w-full
                      h-full
                      bg-transparent
                      overflow-hidden
                    "
                  >
                    <Transition
                      enter-active-class="transition duration-500"
                      enter-from-class="opacity-0"
                      enter-to-class="opacity-100"
                      leave-active-class="transition duration-100"
                      leave-from-class="opacity-100"
                      leave-to-class="opacity-0"
                    >
                      <div
                        @click="handlePlay"
                        v-if="
                          (showPlay &&
                            !play &&
                            getSingleProduct.thumbnailUrl) ||
                          loading
                        "
                        class="
                          absolute
                          cursor-pointer
                          inset-0
                          z-30
                          w-full
                          h-full
                          bg-darkOverlay
                          flex
                          items-center
                          justify-center
                          overflow-hidden
                        "
                      >
                        <div
                          v-if="!loading"
                          class="
                            w-10
                            h-10
                            rounded-full
                            bg-white
                            flex
                            items-center
                            justify-center
                          "
                        >
                          <span
                            class="
                              iconify
                              text-gray-800
                              w-6
                              h-6
                              md:w-8 md:h-8
                              ml-1
                            "
                            data-icon="bi:play-fill"
                            data-inline="false"
                          ></span>
                        </div>

                        <Loader v-if="loading" :white="true" />
                      </div>
                    </Transition>
                    <Transition
                      enter-active-class="transition duration-500"
                      enter-from-class="opacity-0"
                      enter-to-class="opacity-100"
                      leave-active-class="transition duration-100"
                      leave-from-class="opacity-100"
                      leave-to-class="opacity-0"
                    >
                      <img
                        v-if="
                          (!play && getSingleProduct.thumbnailUrl) || loading
                        "
                        :src="getSingleProduct.thumbnailUrl"
                        class="
                          absolute
                          inset-0
                          z-20
                          w-full
                          h-full
                          object-cover
                          overflow-hidden
                        "
                        alt="product image"
                      />
                    </Transition>
                    <div
                      class="
                        absolute
                        z-10
                        inset-0
                        w-full
                        h-full
                        bg-gray-400
                        animate-pulse
                        flex
                        items-center
                        justify-center
                        overflow-hidden
                      "
                    >
                      <svg
                        class="w-12 h-12 text-white"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          d="M2 6a2 2 0 012-2h6a2 2 0 012 2v8a2 2 0 01-2 2H4a2 2 0 01-2-2V6zM14.553 7.106A1 1 0 0014 8v4a1 1 0 00.553.894l2 1A1 1 0 0018 13V7a1 1 0 00-1.447-.894l-2 1z"
                        />
                      </svg>
                    </div>
                    <Transition
                      enter-active-class="transition duration-500"
                      enter-from-class="opacity-0"
                      enter-to-class="opacity-100"
                      leave-active-class="transition duration-100"
                      leave-from-class="opacity-100"
                      leave-to-class="opacity-0"
                    >
                      <video
                        ref="video"
                        v-if="play && getSingleProduct.previewUrl"
                        class="
                          absolute
                          inset-0
                          z-10
                          w-full
                          h-full
                          overflow-hidden
                          focus:outline-none
                        "
                        controls
                        controlsList="nodownload"
                        disablePictureInPicture
                        @ended="play = false"
                        @loadedmetadata="handleLoaded"
                      >
                        <source
                          :src="getSingleProduct.previewUrl"
                          type="video/mp4"
                        />
                        Your browser does not support the video tag.
                      </video>
                    </Transition>
                  </div>
                </div>
              </div>
            </div>
            <!-- end of video -->

            <!-- phptp -->
            <div
              v-if="
                getSingleProduct &&
                getSingleProduct.category.toLowerCase() === 'photo'
              "
              class="w-full"
            >
              <div class="image-container rounded-md overflow-hidden">
                <div class="absolute inset-0 rounded-md overflow-hidden">
                  <div
                    class="
                      relative
                      w-full
                      h-full
                      bg-transparent
                      overflow-hidden
                    "
                  >
                    <img
                      :src="getSingleProduct.thumbnailUrl"
                      class="
                        absolute
                        inset-0
                        z-20
                        w-full
                        h-full
                        object-cover
                        overflow-hidden
                      "
                      alt="product image"
                    />
                  </div>
                </div>
              </div>
            </div>

            <!-- audio -->
            <div
              v-if="getSingleProduct.peaks"
              class="
                w-full
                flex
                items-center
                justify-between
                h-32
                rounded-md
                overflow-hidden
              "
            >
              <div
                class="
                  w-40
                  h-full
                  flex
                  items-center
                  justify-center
                  bg-brandPurple
                "
              >
                <button
                  v-if="!isPlaying"
                  @click="playAudio"
                  class="focus:outline-none"
                >
                  <svg
                    class="h-12 w-12 text-white"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z"
                      clip-rule="evenodd"
                    />
                  </svg>
                </button>
                <button v-else @click="pause" class="focus:outline-none">
                  <svg
                    class="h-12 w-12 text-white"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zM7 8a1 1 0 012 0v4a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v4a1 1 0 102 0V8a1 1 0 00-1-1z"
                      clip-rule="evenodd"
                    />
                  </svg>
                </button>
              </div>

              <!-- audio -->
              <div class="w-full h-full relative">
                <div
                  v-if="!getSingleProduct.peaks"
                  class="
                    absolute
                    h-full
                    inset-0
                    z-30
                    bg-gray-400
                    rounded-md rounded-l-none rounded-b-none
                    animate-pulse
                    flex
                    items-center
                    justify-center
                  "
                >
                  <svg
                    aria-hidden="true"
                    focusable="false"
                    width="2em"
                    height="2em"
                    class="text-white"
                    style="
                      -ms-transform: rotate(360deg);
                      -webkit-transform: rotate(360deg);
                      transform: rotate(360deg);
                    "
                    preserveAspectRatio="xMidYMid meet"
                    viewBox="0 0 1024 1024"
                  >
                    <path
                      d="M960 576v96q0 13-9.5 22.5T928 704t-22.5-9.5T896 672v64q0 13-9.5 22.5T864 768t-22.5-9.5T832 736V608q0 13-9.5 22.5T800 640t-22.5-9.5T768 608v256q0 13-9.5 22.5T736 896t-22.5-9.5T704 864v64q0 13-9.5 22.5T672 960t-22.5-9.5T640 928V608q0 13-9.5 22.5T608 640t-22.5-9.5T576 608v128q0 13-9.5 22.5T544 768t-22.5-9.5T512 736v64q0 13-9.5 22.5T480 832t-22.5-9.5T448 800v192q0 13-9.5 22.5T416 1024t-22.5-9.5T384 992V864q0 13-9.5 22.5T352 896t-22.5-9.5T320 864V672q0 13-9.5 22.5T288 704t-22.5-9.5T256 672v64q0 13-9.5 22.5T224 768t-22.5-9.5T192 736v-64q0 13-9.5 22.5T160 704t-22.5-9.5T128 672v-64q0 13-9.5 22.5T96 640t-22.5-9.5T64 608v-32q-27 0-45.5-19T0 511.5t18.5-45T64 448v-32q0-13 9.5-22.5T96 384t22.5 9.5T128 416v-64q0-13 9.5-22.5T160 320t22.5 9.5T192 352v-64q0-13 9.5-22.5T224 256t22.5 9.5T256 288v64q0-13 9.5-22.5T288 320t22.5 9.5T320 352V160q0-13 9.5-22.5T352 128t22.5 9.5T384 160V32q0-13 9.5-22.5T416 0t22.5 9.5T448 32v192q0-13 9.5-22.5T480 192t22.5 9.5T512 224v64q0-13 9.5-22.5T544 256t22.5 9.5T576 288v128q0-13 9.5-22.5T608 384t22.5 9.5T640 416V96q0-13 9.5-22.5T672 64t22.5 9.5T704 96v64q0-13 9.5-22.5T736 128t22.5 9.5T768 160v256q0-13 9.5-22.5T800 384t22.5 9.5T832 416V288q0-13 9.5-22.5T864 256t22.5 9.5T896 288v64q0-13 9.5-22.5T928 320t22.5 9.5T960 352v96q27 0 45.5 18.5t18.5 45t-18.5 45.5t-45.5 19z"
                      fill="#fff"
                    />
                    <rect
                      x="0"
                      y="0"
                      width="1024"
                      height="1024"
                      fill="rgba(0, 0, 0, 0)"
                    />
                  </svg>
                </div>
                <!-- generated wave -->
                <div
                  id="loadingHead"
                  class="
                    absolute
                    pointer-events-none
                    inset-0
                    z-20
                    bg-audioLoading
                  "
                ></div>

                <!-- current head -->
                <div
                  id="currentHead"
                  class="
                    absolute
                    pointer-events-none
                    inset-0
                    z-20
                    bg-audioCurrent
                    border-brandPurple
                  "
                ></div>
                <div id="wave" class="absolute inset-0 w-full h-fulll"></div>
              </div>

              <!-- end of aidio -->
            </div>

            <!-- end of audio -->
            <!--end of  video or Audio -->

            <div
              class="
                mt-5
                md:mt-24
                w-full
                flex flex-col
                md:gap-10 md:flex-row
                items-center
                justify-between
              "
            >
              <!-- pro afiliation -->
              <div
                v-if="
                  getSingleProduct.category.toLowerCase() ===
                  'royalty free music'
                "
                class="mt-5 w-full rounded-md p-3 border border-gray-600"
              >
                <div class="">
                  <h1
                    v-if="getSingleProduct.affiliation !== 'none'"
                    class="text-xs md:text-sm font-medium text-white"
                  >
                    P.R.O affiliated by {{ getSingleProduct.affiliation }}
                  </h1>
                  <h1
                    v-else
                    class="text-xs md:text-sm font-medium text-gray-200"
                  >
                    No P.R.O affiliation
                  </h1>
                </div>
              </div>
              <!-- end of pro afiliation -->

              <!-- youtube content id  -->
              <div
                v-if="
                  getSingleProduct.category.toLowerCase() ===
                  'royalty free music'
                "
                class="mt-5 w-full rounded-md p-3 border border-gray-600"
              >
                <div class="">
                  <h1
                    v-if="getSingleProduct.youtube !== 'none'"
                    class="text-xs md:text-sm font-medium text-white"
                  >
                    YouTube Content ID registered by
                    {{ getSingleProduct.youtube }}
                  </h1>
                  <h1
                    v-else
                    class="text-xs md:text-sm font-medium text-gray-200"
                  >
                    No YouTube Content ID registration
                  </h1>
                </div>
              </div>
              <!-- end of youtube content id-->
            </div>
          </div>
          <!-- end of product and desc -->

          <!-- download and meta -->
          <div
            class="
              w-full
              md:w-singleMetaWidth
              flex flex-col
              items-start
              justify-start
            "
          >
            <div class="mb-8 w-full flex items-center justify-between">
              <div class="flex items-center justify-center space-x-3">
                <span
                  class="text-xs px-2 py-1 text-white bg-brandPurple rounded"
                  >{{ getSingleProduct.free ? "Free" : "Premium" }}
                </span>
              </div>
              <div class="relative ml-3">
                <!-- collection popup -->
                <div class="focus:outline-none outline-none">
                  <div
                    v-if="isCollection"
                    @click="isCollection = !isCollection"
                    class="fixed z-20 inset-0"
                  ></div>
                  <button
                    @click="handleCollectionClick"
                    class="
                      tooltip
                      w-7
                      h-7
                      rounded-md
                      bg-transparent
                      p-1
                      focus:outline-none
                      flex
                      items-center
                      justify-center
                    "
                  >
                    <span class="hidden lg:block tooltiptext text-xs"
                      >Add to collection</span
                    >
                    <svg
                      class="w-6 h-6 text-buttonColor"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        d="M5 4a2 2 0 012-2h6a2 2 0 012 2v14l-5-2.5L5 18V4z"
                      />
                    </svg>
                  </button>

                  <Transition
                    enter-active-class="transition transform duration-100 ease-in"
                    enter-from-class="opacity-0 scale-95"
                    enter-to-class="opacity-100 scale-100"
                    leave-active-class="transition transform duration-300 ease-out"
                    leave-from-class="opacity-100 scale-100"
                    leave-to-class="opacity-0 scale-95"
                  >
                    <div
                      v-if="isCollection"
                      class="
                        absolute
                        z-20
                        w-72
                        top-0
                        right-0
                        focus:outline-none
                        outline-none
                        rounded-md
                        shadow-lg
                        bg-white
                        overflow-hidden
                        border border-gray-300
                        dark:border-darkBackground
                      "
                    >
                      <div
                        v-if="getCurrentUser"
                        class="w-full p-3 flex items-center justify-between"
                      >
                        <h1 class="text-sm font-semibold text-gray-800">
                          My Collection
                        </h1>
                        <router-link
                          to="/collections"
                          class="text-xs text-brandPurple focus:outline-none"
                          >See All</router-link
                        >
                      </div>

                      <!-- search -->
                      <form
                        v-if="getCurrentUser"
                        @submit.prevent="handleCreateCollection"
                        class="mt-1 mb-3 w-full px-3"
                      >
                        <div
                          class="
                            px-3
                            w-full
                            flex
                            items-center
                            justify-between
                            bg-gray-200
                            rounded-md
                          "
                        >
                          <input
                            type="search"
                            v-model="collectionName"
                            @input="handleSearchInput"
                            placeholder="search or create a collection"
                            class="
                              py-2
                              rounded-md
                              w-full
                              text-sm text-gray-800
                              bg-transparent
                              placeholder-gray-500
                              focus:outline-none
                            "
                          />
                          <svg
                            class="w-5 h-5 text-gray-500"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                              clip-rule="evenodd"
                            />
                          </svg>
                        </div>
                      </form>

                      <!-- end of search -->

                      <!-- suggestion -->
                      <div
                        v-if="getCurrentUser"
                        class="
                          mt-4
                          mb-3
                          px-3
                          h-16
                          overflow-y-auto
                          flex flex-col
                          gap-2
                          items-start
                          justify-start
                        "
                      >
                        <div
                          v-for="collection in getFilteredAvailableCollections"
                          :key="collection.id"
                          class="w-full flex items-center justify-between gap-5"
                        >
                          <span
                            class="truncate text-xs font-medium text-gray-800"
                          >
                            {{ collection.name }}
                          </span>

                          <abbr
                            v-if="
                              collection.products &&
                              collection.products.filter(
                                (p) => p.id === $route.params.id
                              ).length > 0
                            "
                            title="Remove"
                          >
                            <button
                              @click="
                                removeFromCollection({
                                  productId: $route.params.id,
                                  collectionId: collection.id,
                                })
                              "
                              class="
                                p-1
                                text-xs
                                rounded
                                bg-red-100
                                text-gray-700
                                focus:outline-none
                              "
                            >
                              <svg
                                class="w-4 h-4 text-red-800"
                                viewBox="0 0 20 20"
                                fill="currentColor"
                              >
                                <path
                                  fill-rule="evenodd"
                                  d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                                  clip-rule="evenodd"
                                />
                              </svg>
                            </button>
                          </abbr>
                          <abbr v-else title="Add">
                            <button
                              @click="
                                addToCollection({
                                  productId: $route.params.id,
                                  collectionId: collection.id,
                                })
                              "
                              class="
                                p-1
                                text-xs
                                rounded
                                bg-green-100
                                text-white
                                focus:outline-none
                              "
                            >
                              <svg
                                class="w-4 h-4 text-green-800"
                                viewBox="0 0 20 20"
                                fill="currentColor"
                              >
                                <path
                                  fill-rule="evenodd"
                                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v2H7a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V7z"
                                  clip-rule="evenodd"
                                />
                              </svg>
                            </button>
                          </abbr>
                        </div>
                      </div>
                      <!-- end of suggestion -->

                      <!-- create button -->
                      <button
                        v-if="getCurrentUser"
                        @click="handleCreateCollection"
                        class="
                          py-3
                          text-sm text-center
                          bg-gray-200
                          border-t border-gray-300
                          w-full
                          flex
                          items-center
                          justify-center
                          focus:outline-none
                        "
                      >
                        <svg
                          class="w-6 h-6 text-buttonColor"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z"
                            clip-rule="evenodd"
                          />
                        </svg>
                        Create
                      </button>
                      <!-- end of create button -->

                      <!-- if not logged in -->
                      <div v-if="!getCurrentUser" class="p-5">
                        <h1
                          class="text-base font-bold text-gray-800 text-center"
                        >
                          Please create an account to save this item for later
                        </h1>
                        <router-link
                          to="/register"
                          class="
                            mt-5
                            mb-2
                            w-full
                            block
                            px-2
                            py-2
                            md:px-3 md:py-2
                            font-semibold
                            text-center text-gray-900 text-xs
                            md:text-sm
                            bg-brandGreen
                            transition-colors
                            duration-300
                            hover:bg-brandGreenHover
                            rounded-md
                            focus:outline-none
                          "
                        >
                          Create a free account
                        </router-link>

                        <router-link
                          to="/login"
                          class="text-center w-full block text-gray-800 text-xs"
                        >
                          <span>already a member?</span>
                          <span class="text-gray-900 hover:underline">
                            Sign in</span
                          >
                        </router-link>
                      </div>
                      <!-- end of if not logged in -->
                    </div>
                  </Transition>
                </div>
                <!-- end of collection popup -->
              </div>
            </div>
            <!-- <h1
              v-if="
                (!getCurrentUser && !getSingleProduct.peaks) ||
                  (getCurrentUser &&
                    getCurrentUser.subscription === 'free' &&
                    !getSingleProduct.peaks)
              "
              class="text-xl md:text-2xl font-bold text-white"
            >
              Subscribe to unlock unlimited access to premium assets
            </h1> -->

            <!-- features -->
            <!-- <div
              v-if="
               false
              "
              class="mt-5 flex items-center justify-center space-x-2"
            >
              <svg
                class="w-5 h-5 text-brandGreen"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fill-rule="evenodd"
                  d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                  clip-rule="evenodd"
                />
              </svg>
              <h3 class="text-xs md:text-sm text-white">Unlimited Downloads</h3>
            </div>

            <div
              v-if="
                (!getCurrentUser && !getSingleProduct.peaks) ||
                  (getCurrentUser &&
                    getCurrentUser.subscription === 'free' &&
                    !getSingleProduct.peaks)
              "
              class="mt-3 flex items-center justify-center space-x-2"
            >
              <svg
                class="w-5 h-5 text-brandGreen"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fill-rule="evenodd"
                  d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                  clip-rule="evenodd"
                />
              </svg>
              <h3 class="text-xs md:text-sm text-white">
                Simple commercial licensing
              </h3>
            </div>

            <div
              v-if="
                (!getCurrentUser && !getSingleProduct.peaks) ||
                  (getCurrentUser &&
                    getCurrentUser.subscription === 'free' &&
                    !getSingleProduct.peaks)
              "
              class="mt-3 flex items-center justify-center space-x-2"
            >
              <svg
                class="w-5 h-5 text-brandGreen"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fill-rule="evenodd"
                  d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                  clip-rule="evenodd"
                />
              </svg>
              <h3 class="text-xs md:text-sm text-white">
                Access To Whole Library
              </h3>
            </div>

            <div
              v-if="
                (!getCurrentUser && !getSingleProduct.peaks) ||
                  (getCurrentUser &&
                    getCurrentUser.subscription === 'free' &&
                    !getSingleProduct.peaks)
              "
              class="mt-3 flex items-center justify-center space-x-2"
            >
              <svg
                class="w-5 h-5 text-brandGreen"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fill-rule="evenodd"
                  d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                  clip-rule="evenodd"
                />
              </svg>
              <h3 class="text-xs md:text-sm text-white">Regular Updates</h3>
            </div>

            <div
              v-if="
                (!getCurrentUser && !getSingleProduct.peaks) ||
                  (getCurrentUser &&
                    getCurrentUser.subscription === 'free' &&
                    !getSingleProduct.peaks)
              "
              class="mt-3 flex items-center justify-center space-x-2"
            >
              <svg
                class="w-5 h-5 text-brandGreen"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fill-rule="evenodd"
                  d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                  clip-rule="evenodd"
                />
              </svg>
              <h3 class="text-xs md:text-sm text-white">Cancel anytime</h3>
            </div> -->
            <!-- end of features -->

            <!-- meta info -->
            <div class="w-full rounded-md">
              <h1 class="text-sm md:text-base font-bold text-white">
                Attributes
              </h1>

              <div
                v-if="getSingleProduct.length"
                class="mt-2 w-full flex items-center justify-between"
              >
                <h1 class="text-xs text-gray-200">Length</h1>
                <h1 class="text-xs text-gray-200">
                  {{
                    getSingleProduct.length.slice(
                      3,
                      getSingleProduct.length.length
                    )
                  }}
                </h1>
              </div>

              <div
                v-if="getSingleProduct.trackLength"
                class="mt-2 w-full flex items-center justify-between"
              >
                <h1 class="text-xs text-gray-200">Additional track length</h1>
                <h1 class="text-xs text-gray-200">
                  {{ getSingleProduct.trackLength }}
                </h1>
              </div>

              <div
                v-if="getSingleProduct.category.toLowerCase() === 'photo'"
                class="mt-2 w-full flex items-center justify-between"
              >
                <h1 class="text-xs text-gray-200">Orientation</h1>
                <h1 class="text-xs text-gray-200">
                  {{ getSingleProduct.subCategory }}
                </h1>
              </div>

              <div
                v-if="getSingleProduct.resolution"
                class="mt-1 w-full flex items-center justify-between"
              >
                <h1 class="text-xs text-gray-200">Resolution</h1>
                <h1 class="text-xs text-gray-200">
                  {{ getSingleProduct.resolution }}
                </h1>
              </div>

              <div
                v-if="getSingleProduct.bitRate"
                class="mt-1 w-full flex items-center justify-between"
              >
                <h1 class="text-xs text-gray-200">Bit Rate</h1>
                <h1 class="text-xs text-gray-200">
                  {{ getSingleProduct.bitRate }}
                </h1>
              </div>

              <div
                v-if="getSingleProduct.frameRate"
                class="mt-1 w-full flex items-center justify-between"
              >
                <h1 class="text-xs text-gray-200">Frame Rate</h1>
                <h1 class="text-xs text-gray-200">
                  {{ getSingleProduct.frameRate }}
                </h1>
              </div>

              <div
                v-if="getSingleProduct.sampleRate"
                class="mt-1 w-full flex items-center justify-between"
              >
                <h1 class="text-xs text-gray-200">Sample Rate</h1>
                <h1 class="text-xs text-gray-200">
                  {{ getSingleProduct.sampleRate }}
                </h1>
              </div>

              <div
                v-if="getSingleProduct.tempo"
                class="mt-1 w-full flex items-center justify-between"
              >
                <h1 class="text-xs text-gray-200">Tempo</h1>
                <h1 class="text-xs text-gray-200">
                  {{ getSingleProduct.tempo }}
                </h1>
              </div>

              <div
                v-if="getSingleProduct.looped"
                class="mt-1 w-full flex items-center justify-between"
              >
                <h1 class="text-xs text-gray-200">Looped</h1>
                <h1 class="text-xs text-gray-200">yes</h1>
              </div>

              <div
                v-if="getSingleProduct.editorial"
                class="mt-1 w-full flex items-center justify-between"
              >
                <h1 class="text-xs text-gray-200">Editorial</h1>
                <h1 class="text-xs text-gray-200">yes</h1>
              </div>

              <div
                v-if="getSingleProduct.packageSize"
                class="mt-1 w-full flex items-center justify-between"
              >
                <h1 class="text-xs text-gray-200">File Size</h1>
                <h1 class="text-xs text-gray-200">
                  {{ getSingleProduct.packageSize }}
                </h1>
              </div>

              <h1
                v-if="getSingleProduct.format"
                class="mt-5 text-xs md:text-sm font-medium text-white"
              >
                Files Included
              </h1>

              <div
                v-if="getSingleProduct.format"
                class="
                  mt-2
                  w-full
                  flex flex-col
                  space-y-1
                  items-start
                  justify-start
                "
              >
                <h1
                  v-for="format in getSingleProduct.format.split(',')"
                  :key="format"
                  class="text-xs text-gray-200"
                >
                  {{ format }}
                </h1>
              </div>

              <h1
                v-if="getSingleProduct.vocal"
                class="mt-5 text-xs md:text-sm font-medium text-white"
              >
                Vocals
              </h1>

              <div
                v-if="getSingleProduct.vocal"
                class="
                  mt-2
                  w-full
                  flex flex-col
                  space-y-1
                  items-start
                  justify-start
                "
              >
                <h1
                  v-for="vocal in getSingleProduct.vocal.split(',')"
                  :key="vocal"
                  class="text-xs text-gray-200"
                >
                  {{ vocal }}
                </h1>
              </div>

              <h1
                v-if="getSingleProduct.version"
                class="mt-5 text-xs md:text-sm font-medium text-white"
              >
                Application supported
              </h1>

              <div
                v-if="getSingleProduct.version"
                class="
                  mt-2
                  w-full
                  flex flex-col
                  space-y-1
                  items-start
                  justify-start
                "
              >
                <h1
                  v-for="version in getSingleProduct.version.split(',')"
                  :key="version"
                  class="text-xs text-gray-200"
                >
                  {{ version }}
                </h1>
              </div>

              <h1 class="mt-5 text-xs md:text-sm font-medium text-white">
                Commercial License
              </h1>

              <div class="mt-2 w-full flex items-center justify-between">
                <router-link
                  to="/license"
                  class="text-xs text-brandGreen hover:underline"
                >
                  Further information
                </router-link>
              </div>
            </div>
            <!-- end of meta info -->

            <!-- music not included -->
            <div
              v-if="getSingleProduct.stockMusic"
              class="mt-5 w-full rounded-md"
            >
              <div class="">
                <h1 class="text-xs md:text-sm font-medium text-white">
                  Music Not included:
                </h1>
                <h1 class="text-xs md:text-sm font-medium text-white">
                  <router-link
                    :to="`/item/${getSingleProduct.stockMusic.split('/')[4]}/${
                      getSingleProduct.stockMusic.split('/')[5]
                    }`"
                    target="_self"
                    class="
                      text-xs
                      md:text-sm
                      font-medium
                      text-brandGreen
                      hover:underline
                    "
                  >
                    {{
                      getSingleProduct.stockMusic
                        .split("/")[4]
                        .split("-")
                        .join(" ")
                    }}
                  </router-link>
                  <span class="font-normal"> can be downloaded separately</span>
                </h1>
              </div>
            </div>
            <!-- end of music not included-->
          </div>
          <!-- end of download and meta -->
        </div>
        <!-- end of content -->
      </div>
    </div>

    <div v-if="getSingleProduct.productName" class="w-full py-6 pt-3 bg-white">
      <div
        class="
          w-full
          px-3
          xl:px-0
          max-w-1xl
          mx-auto
          flex flex-col-reverse
          md:flex-row
          items-start
          justify-between
          lg:space-x-14
        "
      >
        <div
          class="
            hidden
            w-full
            lg:flex
            flex-col
            items-start
            justify-start
            lg:justify-between
          "
        >
          <div
            class="w-full flex flex-col md:flex-row items-start justify-between"
          >
            <h3
              class="
                text-lg
                flex-shrink-0
                md:text-xl
                font-semibold
                text-gray-800
              "
            >
              About this item
            </h3>

            <div class="flex flex-row gap-5 w-full items-start justify-end">
              <!-- download buttons -->
              <button
                v-if="getSingleProduct.category.toLowerCase() !== 'photo'"
                @click="handlePreviewDownload"
                class="
                  ml-5
                  flex
                  items-center
                  px-3
                  py-2
                  rounded-md
                  border border-gray-600
                  bg-transparent
                  text-gray-900 text-xs
                  md:text-sm
                  font-medium
                  hover:bg-gray-200
                  focus:outline-none
                "
              >
                <span
                  class="w-full whitespace-nowrap"
                  v-if="!getDownloadLoading"
                  >Download Preview</span
                >
                <span
                  v-if="getDownloadLoading"
                  class="w-full flex items-center justify-center"
                  ><Loader :whiteSmall="true"
                /></span>
              </button>

              <div class="w-full max-w-xs">
                <span
                  v-if="!getCurrentUser"
                  class="
                    -mt-10
                    mb-6
                    w-full
                    text-right
                    block
                    text-xs text-gray-100
                  "
                  >Already a Vooaxis member?
                  <router-link
                    class="text-brandGreen hover:underline"
                    to="/login"
                    >Sign in here
                  </router-link></span
                >
                <router-link
                  to="/pricing"
                  v-if="
                    (!getCurrentUser && !getSingleProduct.free) ||
                    (getCurrentUser &&
                      getCurrentUser.subscription === 'free' &&
                      !getSingleProduct.free)
                  "
                  class="
                    text-center
                    px-3
                    py-2
                    block
                    rounded-md
                    bg-brandPurple
                    text-white text-xs
                    md:text-sm
                    font-medium
                    hover:bg-brandPurple
                    focus:outline-none
                  "
                >
                  Subscribe to Download
                </router-link>
                <!-- download popup -->
                <div class="relative w-full focus:outline-none outline-none">
                  <div
                    v-if="isDownload"
                    @click="isDownload = !isDownload"
                    class="fixed z-20 inset-0"
                  ></div>

                  <button
                    @click="handleDownloadClick"
                    v-if="getSingleProduct.free"
                    class="
                      w-full
                      px-3
                      py-2
                      block
                      rounded-md
                      bg-brandPurple
                      text-white text-xs
                      md:text-sm
                      font-medium
                      hover:bg-brandPurple
                      focus:outline-none
                    "
                  >
                    Download For Free
                  </button>

                  <button
                    v-if="
                      !getSingleProduct.free &&
                      getCurrentUser &&
                      getCurrentUser.subscription !== 'free'
                    "
                    @click="handleDownloadClick"
                    class="
                      relative
                      w-full
                      px-3
                      py-2
                      block
                      rounded-md
                      bg-brandPurple
                      text-white text-xs
                      md:text-sm
                      font-medium
                      hover:bg-brandPurple
                      focus:outline-none
                    "
                  >
                    Download
                  </button>

                  <Transition
                    class="absolute z-30"
                    enter-active-class="transition transform duration-100 ease-in"
                    enter-from-class="opacity-0 scale-95"
                    enter-to-class="opacity-100 scale-100"
                    leave-active-class="transition transform duration-300 ease-out"
                    leave-from-class="opacity-100 scale-100"
                    leave-to-class="opacity-0 scale-95"
                  >
                    <div
                      v-if="isDownload"
                      class="
                        absolute
                        w-full
                        bottom-0
                        right-0
                        focus:outline-none
                        outline-none
                        rounded-md
                        shadow-lg
                        bg-white
                        overflow-hidden
                        border border-gray-300
                        dark:border-darkBackground
                      "
                    >
                      <div
                        v-if="
                          getCurrentUser &&
                          getCurrentUser.subscription !== 'free' &&
                          !getSingleProduct.free
                        "
                        class="w-full p-3 flex items-center justify-between"
                      >
                        <h1 class="text-sm font-semibold text-gray-800">
                          Download
                        </h1>
                      </div>

                      <div
                        v-if="getCurrentUser && getSingleProduct.free"
                        class="w-full p-3 flex items-center justify-between"
                      >
                        <h1 class="text-sm font-semibold text-gray-800">
                          Download Free
                        </h1>
                      </div>

                      <h1
                        v-if="getSingleProduct.free && getCurrentUser"
                        class="mb-5 px-3 text-sm text-gray-700"
                      >
                        This free item is available to you to use only once for
                        a single project. Enjoy your free file!!
                      </h1>

                      <div
                        v-if="getSingleProduct.free && getCurrentUser"
                        class="w-full flex flex-start px-3 mt-5"
                      >
                        <CustomRoundedCheckbox
                          v-on:clicked="isPolicy = !isPolicy"
                          lable="I agree to the Free Files Single Use Policy."
                          :select="isPolicy"
                          :truncate="false"
                        />
                      </div>

                      <h1
                        v-if="getSingleProduct.free && getCurrentUser"
                        class="
                          pl-10
                          ml-1
                          mt-1
                          mb-5
                          text-xs text-gray-600
                          italic
                        "
                      >
                        see our
                        <router-link to="#" class="underline"
                          >Free files Policy</router-link
                        >
                      </h1>

                      <!-- search -->
                      <form
                        v-if="
                          !getSingleProduct.free &&
                          getCurrentUser &&
                          getCurrentUser.subscription !== 'free'
                        "
                        @submit.prevent="handleCreateCollection"
                        class="mt-1 mb-3 w-full px-3"
                      >
                        <div
                          class="
                            px-3
                            w-full
                            flex
                            items-center
                            justify-between
                            bg-gray-200
                            rounded-md
                          "
                        >
                          <input
                            type="search"
                            v-model="licenseName"
                            @input="handleLicense"
                            placeholder="Enter license name"
                            class="
                              py-2
                              rounded-md
                              w-full
                              text-sm text-gray-800
                              bg-transparent
                              placeholder-gray-500
                              focus:outline-none
                            "
                          />
                        </div>
                      </form>

                      <!-- end of search -->

                      <!-- doanload button -->
                      <button
                        v-if="
                          !getSingleProduct.free &&
                          getCurrentUser &&
                          getCurrentUser.subscription !== 'free'
                        "
                        @click="handleDownload"
                        :class="[
                          !activateDownload
                            ? 'text-gray-400 pointer-events-none'
                            : 'text-gray-800',
                          { 'pointer-events-none': getDownloadLoading },
                        ]"
                        class="
                          py-3
                          text-sm text-center
                          bg-gray-200
                          border-t border-gray-300
                          w-full
                          flex
                          items-center
                          justify-center
                          focus:outline-none
                        "
                      >
                        <Loader v-if="getDownloadLoading" :bright="true" />
                        <svg
                          v-if="!getDownloadLoading"
                          :class="
                            !activateDownload
                              ? 'text-gray-400 pointer-events-none'
                              : 'text-buttonColor'
                          "
                          class="w-5 h-5 mr-1"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v3.586L7.707 9.293a1 1 0 00-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L11 10.586V7z"
                            clip-rule="evenodd"
                          />
                        </svg>
                        <span v-if="!getDownloadLoading">Download</span>
                      </button>

                      <!-- free download button -->
                      <button
                        v-if="getSingleProduct.free && getCurrentUser"
                        @click="handleFreeDownload"
                        :class="[
                          !isPolicy
                            ? 'text-gray-400 pointer-events-none'
                            : 'text-gray-800',
                          { 'pointer-events-none': getDownloadLoading },
                        ]"
                        class="
                          py-3
                          text-sm text-center
                          bg-gray-200
                          border-t border-gray-300
                          w-full
                          flex
                          items-center
                          justify-center
                          focus:outline-none
                        "
                      >
                        <Loader v-if="getDownloadLoading" :bright="true" />
                        <svg
                          v-if="!getDownloadLoading"
                          :class="
                            !isPolicy
                              ? 'text-gray-400 pointer-events-none'
                              : 'text-buttonColor'
                          "
                          class="w-5 h-5 mr-1"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v3.586L7.707 9.293a1 1 0 00-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L11 10.586V7z"
                            clip-rule="evenodd"
                          />
                        </svg>
                        <span v-if="!getDownloadLoading">Download</span>
                      </button>
                      <!-- end of doanload button -->

                      <!-- if not logged in -->
                      <div
                        v-if="
                          !getCurrentUser ||
                          (getCurrentUser &&
                            getCurrentUser.subscription === 'free')
                        "
                      >
                        <h1
                          v-if="!getSingleProduct.free"
                          class="
                            text-base
                            pt-5
                            font-bold
                            text-gray-800 text-center
                          "
                        >
                          Subscribe to get this item and unlimited downloads for
                          your Creative Project.
                        </h1>
                        <h1
                          v-if="getSingleProduct.free && !getCurrentUser"
                          class="
                            text-base
                            pt-5
                            px-3
                            font-bold
                            text-gray-800 text-center
                          "
                        >
                          Create a free Vooaxis account to unlock this item is
                          free to download.
                        </h1>
                        <div v-if="!getSingleProduct.free" class="px-3 pb-5">
                          <router-link
                            to="/pricing"
                            class="
                              mt-5
                              mb-2
                              w-full
                              block
                              px-2
                              py-2
                              md:px-3 md:py-2
                              font-semibold
                              text-center text-gray-900 text-xs
                              md:text-sm
                              bg-brandGreen
                              transition-colors
                              duration-300
                              hover:bg-brandGreenHover
                              rounded-md
                              focus:outline-none
                            "
                          >
                            Subscribe to download
                          </router-link>
                        </div>

                        <div
                          v-if="getSingleProduct.free && !getCurrentUser"
                          class="px-3"
                        >
                          <router-link
                            to="/register"
                            class="
                              mt-5
                              mb-2
                              w-full
                              block
                              px-2
                              py-2
                              md:px-3 md:py-2
                              font-semibold
                              text-center text-gray-900 text-xs
                              md:text-sm
                              bg-brandGreen
                              transition-colors
                              duration-300
                              hover:bg-brandGreenHover
                              rounded-md
                              focus:outline-none
                            "
                          >
                            Create an account
                          </router-link>
                        </div>

                        <router-link
                          v-if="!getCurrentUser && !getSingleProduct.free"
                          to="/login"
                          class="
                            text-center
                            pb-5
                            w-full
                            block
                            text-gray-800 text-xs
                          "
                        >
                          <span>already a Vooaxis member?</span>
                          <span class="text-brandGreen hover:underline">
                            Sign in here</span
                          >
                        </router-link>

                        <router-link
                          v-if="!getCurrentUser && getSingleProduct.free"
                          to="/login"
                          class="
                            text-center
                            pb-5
                            w-full
                            block
                            text-gray-800 text-xs
                          "
                        >
                          <span>already an Vooaxis member?</span>
                          <span class="text-brandPurple hover:underline">
                            Sign in here</span
                          >
                        </router-link>
                      </div>
                      <!-- end of if not logged in -->
                    </div>
                  </Transition>
                </div>
                <!-- end of collection popup -->
              </div>
              <!-- end of download buttons -->
            </div>
          </div>

          <div
            class="
              w-full
              flex flex-col
              md:flex-row
              items-start
              justify-start
              lg:justify-between
            "
          >
            <div
              class="
                w-full
                mt-10
                text-lg
                md:text-xl
                font-semibold
                text-gray-600
              "
            >
              <p v-if="getSingleProduct.description" class="text-sm">
                <span
                  v-for="text in getSingleProduct.description.split('<br>')"
                  :key="text"
                  >{{ text }}<br
                /></span>
              </p>
            </div>
          </div>
        </div>

        <!-- mobile description -->
        <div class="mt-3 w-full lg:hidden">
          <h3 class="text-lg font-semibold text-gray-800">About this item</h3>
          <div
            class="
              w-full
              max-w-2xl
              mt-3
              text-lg
              md:text-xl
              font-semibold
              text-gray-600
            "
          >
            <p v-if="getSingleProduct.description" class="text-sm">
              <span
                v-for="text in getSingleProduct.description.split('<br>')"
                :key="text"
                >{{ text }}<br
              /></span>
            </p>
          </div>

          <h3 class="mt-5 text-lg font-semibold text-gray-800">Tags</h3>

          <div
            v-if="getSingleProduct.description"
            class="mt-3 flex flex-wrap w-full gap-3"
          >
            <router-link
              :to="`/${getSingleProduct.category
                .toLowerCase()
                .split(' ')
                .join('-')}/pg-1?search=${tag}`"
              v-for="tag in getSingleProduct.tags.split(',')"
              :key="tag"
              class="
                rounded-md
                border border-gray-700
                px-3
                py-1
                text-xs text-gray-700
                hover:bg-gray-200
              "
              >{{ tag }}</router-link
            >
          </div>
        </div>

        <div
          class="
            w-full
            hidden
            lg:flex
            justify-end
            items-end
            flex-col
            lg:w-singleMetaWidth
          "
        >
          <h3 class="text-lg md:text-xl font-semibold text-gray-800">Tags</h3>
          <div
            v-if="getSingleProduct.description"
            class="mt-10 flex justify-end flex-wrap w-full gap-3"
          >
            <router-link
              :to="`/${getSingleProduct.category
                .toLowerCase()
                .split(' ')
                .join('-')}/pg-1?search=${tag}`"
              v-for="tag in getSingleProduct.tags.split(',')"
              :key="tag"
              class="
                rounded-md
                border border-gray-700
                px-3
                py-1
                text-xs text-gray-700
                hover:bg-gray-200
              "
              >{{ tag }}</router-link
            >
          </div>
        </div>
      </div>
    </div>
    <!-- similar -->
    <div v-if="getSingleProduct.productName" class="bg-subtleGray">
      <div class="mt-10 w-full max-w-1xl mx-auto px-3 md:px-6 2xl:px-0 py-10">
        <div
          class="
            w-full
            pb-20
            flex flex-col
            items-start
            justify-start
            space-y-16
          "
        >
          <div
            v-if="getSimilarProduct.length > 0"
            :class="
              getSimilarProduct &&
              getSimilarProduct.length > 0 &&
              getSimilarProduct[0].peaks
                ? ' grid-cols-1 md:grid-cols-3'
                : ' grid-cols-1 md:grid-cols-4'
            "
            class="mb-20 grid w-full select-none gap-8"
          >
            <!-- title and info -->
            <div
              :class="
                getSimilarProduct && getSimilarProduct[0].peaks
                  ? 'md:col-span-3'
                  : 'md:col-span-4'
              "
              class="
                flex flex-col
                md:flex-row
                items-start
                md:items-center
                justify-between
              "
            >
              <!-- title -->
              <h1 class="mt-3 text-base md:text-2xl text-gray-800 font-bold">
                Similar {{ getSingleProduct.category }}
              </h1>
              <!-- end of title -->

              <!-- divider -->
              <!-- <div class="my-5 w-full border-t border-gray-300"></div> -->
              <!--end of  divider -->

              <!-- see more button -->
              <router-link
                :to="{
                  name: getSingleProduct.category.toLowerCase(),
                  params: { ...$route.params },
                  query: { ...$route.query },
                }"
                class="
                  group
                  mt-2
                  px-3
                  py-2
                  text-xs
                  font-medium
                  hover:text-white
                  text-gray-900
                  rounded-md
                  bg-transparent
                  border border-gray-900
                  hover:bg-gray-900
                  focus:outline-none
                  flex
                  items-center
                  justify-center
                "
              >
                See more
                <svg
                  class="w-4 h-4 ml-2 text-gray-900 group-hover:text-white"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fill-rule="evenodd"
                    d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z"
                    clip-rule="evenodd"
                  />
                </svg>
              </router-link>
              <!--end of see more button -->
            </div>
            <!-- end of title and info -->

            <!-- cards -->
            <div v-for="product in getSimilarProduct" :key="product" class="">
              <ProductVideoCard
                v-if="!product.peaks"
                :id="product.id"
                :thumbnail="product.thumbnailUrl"
                :video="product.previewUrl"
                :author="product.user.userName"
                :authorId="product.user.id"
                :title="product.productName"
                :date="product.updatedAt.split('T')[0]"
              />
              <NewMiniAudio
                v-else
                :currentCategory="product.category"
                :id="product.id"
                :audioUrl="product.previewUrl"
                :author="product.user.userName"
                :authorId="product.user.id"
                :title="product.productName"
                :peaks="product.peaks"
                :trackLength="product.trackLength"
                :bpm="product.tempo"
                :length="product.length"
                :date="product.updatedAt.split('T')[0]"
              />
            </div>

            <!-- end of cards -->
          </div>
          <div
            v-if="getAuthorSimilarProduct.length > 0"
            :class="
              getSimilarProduct &&
              getSimilarProduct.length > 0 &&
              getSimilarProduct[0].peaks
                ? ' grid-cols-1 md:grid-cols-3'
                : ' grid-cols-1 md:grid-cols-4'
            "
            class="mb-20 grid w-full select-none gap-8"
          >
            <!-- title and info -->
            <div
              :class="
                getSimilarProduct &&
                getSimilarProduct[0] &&
                getSimilarProduct[0].peaks
                  ? 'md:col-span-3'
                  : 'md:col-span-4'
              "
              class="
                flex flex-col
                md:flex-row
                items-start
                md:items-center
                justify-between
              "
            >
              <!-- title -->
              <h1 class="mt-3 text-base md:text-2xl text-gray-800 font-bold">
                More From {{ getSingleProduct.user.userName }}
              </h1>
              <!-- end of title -->

              <!-- divider -->
              <!-- <div class="my-5 w-full border-t border-gray-300"></div> -->
              <!--end of  divider -->

              <!-- see more button -->
              <router-link
                :to="`/user/${getSingleProduct.user.userName}`"
                class="
                  group
                  mt-2
                  px-3
                  py-2
                  text-xs
                  font-medium
                  hover:text-white
                  text-gray-900
                  rounded-md
                  bg-transparent
                  border border-gray-900
                  hover:bg-gray-900
                  focus:outline-none
                  flex
                  items-center
                  justify-center
                "
              >
                See more
                <svg
                  class="w-4 h-4 ml-2 text-gray-900 group-hover:text-white"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fill-rule="evenodd"
                    d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z"
                    clip-rule="evenodd"
                  />
                </svg>
              </router-link>
              <!--end of see more button -->
            </div>
            <!-- end of title and info -->

            <!-- cards -->
            <div
              v-for="product in getAuthorSimilarProduct"
              :key="product"
              class=""
            >
              <ProductVideoCard
                v-if="!product.peaks"
                :id="product.id"
                :thumbnail="product.thumbnailUrl"
                :video="product.previewUrl"
                :author="product.user.userName"
                :authorId="product.user.id"
                :title="product.productName"
                :date="product.updatedAt.split('T')[0]"
              />
              <NewMiniAudio
                v-else
                :currentCategory="product.category"
                :id="product.id"
                :audioUrl="product.previewUrl"
                :author="product.user.userName"
                :authorId="product.user.id"
                :title="product.productName"
                :peaks="product.peaks"
                :trackLength="product.trackLength"
                :bpm="product.tempo"
                :length="product.length"
                :date="product.updatedAt.split('T')[0]"
              />
            </div>

            <!-- end of cards -->
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import WaveSurfer from "wavesurfer.js";
import { mapActions, mapGetters } from "vuex";
import MiniProductAudioCard from "../components/utils/MiniProductAudioCard.vue";
import ProductVideoCard from "../components/utils/ProductVideoCard.vue";
import CustomRoundedCheckbox from "../components/utils/CustomRoundedCheckbox.vue";
import Loader from "../components/utils/Loader.vue";
import NewMiniAudio from "../components/utils/NewMiniAudio.vue";
export default {
  name: "SingleItem",
  components: {
    Loader,
    MiniProductAudioCard,
    ProductVideoCard,
    CustomRoundedCheckbox,
    NewMiniAudio,
  },
  mounted() {
    this.fetchAvailableCollections();
    if (this.date) {
      const currentDate = new Date().getMonth();
      const productDate = parseInt(this.date.split("-")[1]) - 1;
      if (currentDate === productDate) {
        this.isNew = true;
      } else {
        this.isNew = false;
      }
    }

    this.fetchSingleProduct(this.$route.params.id);
  },
  computed: {
    ...mapGetters(["getSingleProduct"]),
    ...mapGetters(["getSimilarProduct"]),
    ...mapGetters(["getAuthorSimilarProduct"]),
    ...mapGetters(["getCurrentUser"]),
    ...mapGetters(["getFilteredAvailableCollections"]),
    ...mapGetters(["getDownloadLoading"]),
    ...mapGetters(["getIsDownloaded"]),
  },
  methods: {
    ...mapActions(["createCollection"]),
    ...mapActions(["fetchAvailableCollections"]),
    ...mapActions(["addToCollection"]),
    ...mapActions(["removeFromCollection"]),
    ...mapActions(["filterCollections"]),
    ...mapActions(["fetchSingleProduct"]),
    ...mapActions(["fetchSimilarProduct"]),
    ...mapActions(["fetchAuthorSimilarProduct"]),
    ...mapActions(["downloadProduct"]),
    ...mapActions(["downloadFreeProduct"]),
    ...mapActions(["downloadPreview"]),
    ...mapActions(["appendAlert"]),

    handleLoaded() {
      this.loading = false;
      setTimeout(() => {
        this.$refs.video.play();
      }, 100);
    },
    handlePlay() {
      this.play = true;
      this.loading = true;
    },

    playAudio() {
      clearInterval(this.currentLoadInterval);
      if (!this.audio) {
        this.genAudio();
      }
      this.isPlaying = true;
      this.audio.play();

      this.currentLoadInterval = setInterval(() => {
        console.log("playing");
        const currentTime = this.audio.currentTime;
        const totalTime = this.audio.duration;

        const per = (currentTime / totalTime) * 100;
        console.log({ per });
        document.getElementById(`currentHead`).style.width = `${per}%`;
        document.getElementById(`currentHead`).classList.add("border-r");
      }, 20);
    },

    pause() {
      this.isPlaying = false;
      this.audio.pause();
      clearInterval(this.currentLoadInterval);
    },

    genAudio() {
      const audio = document.createElement("audio");
      audio.src = this.getSingleProduct.previewUrl;
      let loader = this.loadingPercentage;
      audio.addEventListener("progress", function () {
        var range = 0;
        var bf = this.buffered;
        var time = this.currentTime;

        while (!(bf.start(range) <= time && time <= bf.end(range))) {
          range += 1;
        }
        const currentTime = this.currentTime;
        const totalTime = this.duration;

        const per = (currentTime / totalTime) * 100;

        const loadStartPercentage = bf.start(range) / this.duration;
        const loadEndPercentage = bf.end(range) / this.duration;

        const loadPercentage = (
          (loadEndPercentage - loadStartPercentage) *
          100
        ).toFixed(2);

        loader = parseFloat(per) + parseFloat(loadPercentage);

        document.getElementById(`loadingHead`).style.width = `${
          parseFloat(per) + parseFloat(loadPercentage)
        }%`;
      });

      let isPlay = this.isPlaying;
      audio.addEventListener("ended", (e) => {
        clearInterval(this.currentLoadInterval);
        this.pause();
        this.currentTime = 0;
        isPlay = false;
        document.getElementById(`currentHead`).style.width = `0%`;
        document.getElementById(`currentHead`).classList.remove("border-r");
      });

      this.audio = audio;
    },

    handlePreviewDownload() {
      if (
        !this.getCurrentUser ||
        (this.getCurrentUser && this.getCurrentUser.isEmailVerified)
      ) {
        this.downloadPreview({
          id: this.$route.params.id,
          router: this.$router,
        });
      } else {
        this.appendAlert({
          id: Math.floor(Math.random() * 10000),
          title: "Your Email is not yet verified",
          sub: "Click the link sent to your email to verify your account",
          icon: "bi:info-circle-fill",
          type: "warning",
          button: {
            name: "Resend Verification email",
            action: "resendVerificationEmail",
          },
        });
      }
    },

    handleDownloadClick() {
      if (
        !this.getCurrentUser ||
        (this.getCurrentUser && this.getCurrentUser.isEmailVerified)
      ) {
        this.isDownload = true;
      } else {
        this.appendAlert({
          id: Math.floor(Math.random() * 10000),
          title: "Your Email is not yet verified",
          sub: "Click the link sent to your email to verify your account",
          icon: "bi:info-circle-fill",
          type: "warning",
          button: {
            name: "Resend Verification email",
            action: "resendVerificationEmail",
          },
        });
      }
    },

    handleCollectionClick() {
      if (
        !this.getCurrentUser ||
        (this.getCurrentUser && this.getCurrentUser.isEmailVerified)
      ) {
        this.isCollection = true;
      } else {
        this.appendAlert({
          id: Math.floor(Math.random() * 10000),
          title: "Your Email is not yet verified",
          sub: "Click the link sent to your email to verify your account",
          icon: "bi:info-circle-fill",
          type: "warning",
          button: {
            name: "Resend Verification email",
            action: "resendVerificationEmail",
          },
        });
      }
    },

    handleFreeDownload() {
      this.downloadFreeProduct(this.$route.params.id);
    },

    handleSearchInput(e) {
      this.filterCollections(e.target.value);
    },

    handleLicense() {
      if (this.licenseName.length <= 0) {
        this.activateDownload = false;
      } else {
        this.activateDownload = true;
      }
    },

    handleDownload() {
      this.downloadProduct({
        id: this.$route.params.id,
        license: this.licenseName,
        type: "download",
      });
    },

    handleCreateCollection() {
      if (
        this.collectionName.length > 0 &&
        this.getFilteredAvailableCollections.length <= 0
      ) {
        this.createCollection({
          name: this.collectionName,
          id: this.$route.params.id,
        });
        this.collectionName = "";
      }
    },
  },

  watch: {
    getIsDownloaded: function (nv, ov) {
      if (nv) {
        this.licenseName = "";
        (this.isDownload = false), (this.isPolicy = false);
      }
    },

    $route(to, from) {
      if (to.params.name) {
        this.fetchSingleProduct(to.params.id);
      }
      clearInterval(this.currentLoadInterval);
      if (this.audio) {
        this.audio.pause();
      }
    },
    getSingleProduct: function (nv) {
      if (!nv || nv.length <= 0) {
        //this.$router.push("/");
      }
      window.scrollTo({ top: 0, left: 0 });

      if (nv.peaks) {
        setTimeout(() => {
          let play = () => {
            if (!this.audio) {
              this.genAudio();
            }
            this.isPlaying = true;
            this.audio.play();
            clearInterval(this.currentLoadInterval);
            this.currentLoadInterval = setInterval(() => {
              const currentTime = this.audio.currentTime;
              const totalTime = this.audio.duration;

              const per = (currentTime / totalTime) * 100;

              document.getElementById(`currentHead`).style.width = `${per}%`;
              document.getElementById(`currentHead`).classList.add("border-r");
            }, 20);
          };
          document.getElementById(`currentHead`).style.width = `0%`;
          document.getElementById(`loadingHead`).style.width = `0%`;
          const wavesurfer2 = WaveSurfer.create({
            container: `#wave`,
            waveColor: "#CBD5E1",
            progressColor: "transparent",
            cursorColor: "transparent",
            mediaType: "audio",
            height: 130,
            autoCenter: true,
            responsive: true,
            backend: "MediaElement",
            hideScrollbar: true,
          });

          this.Wave = wavesurfer2;

          wavesurfer2.backend.peaks = nv.peaks;

          wavesurfer2.peaks = nv.peaks;

          //Draw peaks
          wavesurfer2.drawBuffer();

          wavesurfer2.on("seek", (e) => {
            if (!this.audio) {
              this.genAudio();
              setTimeout(() => {
                play();
                this.isPlaying = true;
                const seek = e * this.audio.duration;
                const currentTime = this.audio.currentTime;
                const totalTime = this.audio.duration;

                const per = (seek / totalTime) * 100;
                document.getElementById(`currentHead`).style.width = `${per}%`;
                document
                  .getElementById(`currentHead`)
                  .classList.add("border-r");
                this.audio.currentTime = seek.toFixed(2);
              }, 400);
            } else {
              play();
              this.isPlaying = true;
              const seek = e * this.audio.duration;
              const currentTime = this.audio.currentTime;
              const totalTime = this.audio.duration;

              const per = (seek / totalTime) * 100;
              document.getElementById(`currentHead`).style.width = `${per}%`;
              document.getElementById(`currentHead`).classList.add("border-r");
              this.audio.currentTime = seek.toFixed(2);
            }
          });
        }, 200);
      }

      if (nv.id) {
        this.fetchSimilarProduct({
          id: nv.id,
          tags: nv.tags,
          category: nv.category,
        });
        this.fetchAuthorSimilarProduct({
          id: nv.id,
          userId: nv.user.id,
          category: nv.category,
        });
      }
    },
  },

  data() {
    return {
      play: false,
      showPlay: false,
      loading: false,

      audio: null,

      loading: false,

      isPlaying: false,

      duration: 0.0,

      WaveSurfer2: {},

      peaks: null,

      isNew: false,

      isCollection: false,

      isDownload: false,

      licenseName: "",

      isPolicy: false,

      currentLoadInterval: null,
    };
  },
};
</script>
<style scoped>
.image-container {
  position: relative;
  width: 100%;
  padding-top: 56.25%; /* 16:9 Aspect Ratio */
}
/* Tooltip container */
.tooltip {
  z-index: 20;
  position: relative;
  display: inline-block;
}

.tooltip .tooltiptext {
  visibility: hidden;
  width: 120px;
  background-color: #27272a;
  color: #fafafa;
  text-align: center;
  border-radius: 6px;
  padding: 5px 5px;
  position: absolute;
  z-index: 50;
  bottom: 100%;
  left: 50%;
  margin-left: -60px;
  margin-bottom: 10px;
}

.tooltip .tooltiptext::after {
  content: " ";
  position: absolute;
  top: 100%; /* At the bottom of the tooltip */
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #27272a transparent transparent transparent;
}

/* Show the tooltip text when you mouse over the tooltip container */
.tooltip:hover .tooltiptext {
  visibility: visible;
}

.prern {
  background-color: #181818;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100%25'%3E%3Cdefs%3E%3ClinearGradient id='a' gradientUnits='userSpaceOnUse' x1='0' x2='0' y1='0' y2='100%25' gradientTransform='rotate(0,842,429)'%3E%3Cstop offset='0' stop-color='%23181818'/%3E%3Cstop offset='1' stop-color='%23404040'/%3E%3C/linearGradient%3E%3Cpattern patternUnits='userSpaceOnUse' id='b' width='436' height='363.3' x='0' y='0' viewBox='0 0 1080 900'%3E%3Cg fill-opacity='0.1'%3E%3Cpolygon fill='%23444' points='90 150 0 300 180 300'/%3E%3Cpolygon points='90 150 180 0 0 0'/%3E%3Cpolygon fill='%23AAA' points='270 150 360 0 180 0'/%3E%3Cpolygon fill='%23DDD' points='450 150 360 300 540 300'/%3E%3Cpolygon fill='%23999' points='450 150 540 0 360 0'/%3E%3Cpolygon points='630 150 540 300 720 300'/%3E%3Cpolygon fill='%23DDD' points='630 150 720 0 540 0'/%3E%3Cpolygon fill='%23444' points='810 150 720 300 900 300'/%3E%3Cpolygon fill='%23FFF' points='810 150 900 0 720 0'/%3E%3Cpolygon fill='%23DDD' points='990 150 900 300 1080 300'/%3E%3Cpolygon fill='%23444' points='990 150 1080 0 900 0'/%3E%3Cpolygon fill='%23DDD' points='90 450 0 600 180 600'/%3E%3Cpolygon points='90 450 180 300 0 300'/%3E%3Cpolygon fill='%23666' points='270 450 180 600 360 600'/%3E%3Cpolygon fill='%23AAA' points='270 450 360 300 180 300'/%3E%3Cpolygon fill='%23DDD' points='450 450 360 600 540 600'/%3E%3Cpolygon fill='%23999' points='450 450 540 300 360 300'/%3E%3Cpolygon fill='%23999' points='630 450 540 600 720 600'/%3E%3Cpolygon fill='%23FFF' points='630 450 720 300 540 300'/%3E%3Cpolygon points='810 450 720 600 900 600'/%3E%3Cpolygon fill='%23DDD' points='810 450 900 300 720 300'/%3E%3Cpolygon fill='%23AAA' points='990 450 900 600 1080 600'/%3E%3Cpolygon fill='%23444' points='990 450 1080 300 900 300'/%3E%3Cpolygon fill='%23222' points='90 750 0 900 180 900'/%3E%3Cpolygon points='270 750 180 900 360 900'/%3E%3Cpolygon fill='%23DDD' points='270 750 360 600 180 600'/%3E%3Cpolygon points='450 750 540 600 360 600'/%3E%3Cpolygon points='630 750 540 900 720 900'/%3E%3Cpolygon fill='%23444' points='630 750 720 600 540 600'/%3E%3Cpolygon fill='%23AAA' points='810 750 720 900 900 900'/%3E%3Cpolygon fill='%23666' points='810 750 900 600 720 600'/%3E%3Cpolygon fill='%23999' points='990 750 900 900 1080 900'/%3E%3Cpolygon fill='%23999' points='180 0 90 150 270 150'/%3E%3Cpolygon fill='%23444' points='360 0 270 150 450 150'/%3E%3Cpolygon fill='%23FFF' points='540 0 450 150 630 150'/%3E%3Cpolygon points='900 0 810 150 990 150'/%3E%3Cpolygon fill='%23222' points='0 300 -90 450 90 450'/%3E%3Cpolygon fill='%23FFF' points='0 300 90 150 -90 150'/%3E%3Cpolygon fill='%23FFF' points='180 300 90 450 270 450'/%3E%3Cpolygon fill='%23666' points='180 300 270 150 90 150'/%3E%3Cpolygon fill='%23222' points='360 300 270 450 450 450'/%3E%3Cpolygon fill='%23FFF' points='360 300 450 150 270 150'/%3E%3Cpolygon fill='%23444' points='540 300 450 450 630 450'/%3E%3Cpolygon fill='%23222' points='540 300 630 150 450 150'/%3E%3Cpolygon fill='%23AAA' points='720 300 630 450 810 450'/%3E%3Cpolygon fill='%23666' points='720 300 810 150 630 150'/%3E%3Cpolygon fill='%23FFF' points='900 300 810 450 990 450'/%3E%3Cpolygon fill='%23999' points='900 300 990 150 810 150'/%3E%3Cpolygon points='0 600 -90 750 90 750'/%3E%3Cpolygon fill='%23666' points='0 600 90 450 -90 450'/%3E%3Cpolygon fill='%23AAA' points='180 600 90 750 270 750'/%3E%3Cpolygon fill='%23444' points='180 600 270 450 90 450'/%3E%3Cpolygon fill='%23444' points='360 600 270 750 450 750'/%3E%3Cpolygon fill='%23999' points='360 600 450 450 270 450'/%3E%3Cpolygon fill='%23666' points='540 600 630 450 450 450'/%3E%3Cpolygon fill='%23222' points='720 600 630 750 810 750'/%3E%3Cpolygon fill='%23FFF' points='900 600 810 750 990 750'/%3E%3Cpolygon fill='%23222' points='900 600 990 450 810 450'/%3E%3Cpolygon fill='%23DDD' points='0 900 90 750 -90 750'/%3E%3Cpolygon fill='%23444' points='180 900 270 750 90 750'/%3E%3Cpolygon fill='%23FFF' points='360 900 450 750 270 750'/%3E%3Cpolygon fill='%23AAA' points='540 900 630 750 450 750'/%3E%3Cpolygon fill='%23FFF' points='720 900 810 750 630 750'/%3E%3Cpolygon fill='%23222' points='900 900 990 750 810 750'/%3E%3Cpolygon fill='%23222' points='1080 300 990 450 1170 450'/%3E%3Cpolygon fill='%23FFF' points='1080 300 1170 150 990 150'/%3E%3Cpolygon points='1080 600 990 750 1170 750'/%3E%3Cpolygon fill='%23666' points='1080 600 1170 450 990 450'/%3E%3Cpolygon fill='%23DDD' points='1080 900 1170 750 990 750'/%3E%3C/g%3E%3C/pattern%3E%3C/defs%3E%3Crect x='0' y='0' fill='url(%23a)' width='100%25' height='100%25'/%3E%3Crect x='0' y='0' fill='url(%23b)' width='100%25' height='100%25'/%3E%3C/svg%3E");
  background-attachment: fixed;
  background-size: cover;
}
</style>
